import { photo, type ResponsiveImage } from "./photos";

export interface HeroSlide {
  /** Responsive photo shown full-bleed behind the hero, or null for a branded slide. */
  image: ResponsiveImage | null;
  alt: string;
}

/**
 * Background slideshow behind the hero. Uses real supplied job photography.
 * Each slide is a full-bleed, crossfading image; a dark scrim over the top
 * (see Hero.tsx) keeps the headline readable. The first slide loads eagerly
 * as the LCP image. To change the rotation, swap the `photo("...")` keys.
 */
export const heroSlides: HeroSlide[] = [
  {
    image: photo("wall-opening"),
    alt: "A new opening cut into a precast concrete wall",
  },
  {
    image: photo("concrete-removal"),
    alt: "Concrete and masonry removal on a commercial site",
  },
];
